import { useMemo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCards, Pagination, Keyboard, Autoplay } from "swiper"; // legacy import for your Swiper
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/pagination";
import "./Testimonials.css";
import Review from "./Review/Review";
import { REVIEWS } from "../../../assets/utils/reviews";
import FullScreen from "../../ProductPage/FullScreen/FullScreen";
import useWindowSize from "../../../assets/hooks/useWindowSize";
import TotalReviews from "../../TotalReviews/TotalReviews";

// register modules (legacy)
SwiperCore.use([EffectCards, Pagination, Keyboard, Autoplay]);

function Testimonials({ title = '', className }) {
  const { width } = useWindowSize()
  const slides = useMemo(() => REVIEWS ?? [], []);
  // when not null -> fullscreen is open and contains a prepared { files: [...] } object
  const [isFullScreen, setFullScreen] = useState(null);

  const autoplayCfg =
    isFullScreen
      ? false // pause autoplay while fullscreen is open
      : {
        delay: 4500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };

  return (
    <section className={`testimonials ${className ? className : ''}`}>
      {title ? <p className="testimonials__title">{title}</p> : null}
      <div className="testimonials__swiper-wrap">
        <Swiper
          effect="cards"
          grabCursor
          centeredSlides
          // autoHeight={false}
          keyboard={{ enabled: true }}
          autoplay={autoplayCfg}

          cardsEffect={{
            perSlideOffset: width <= 550 ? 16 : 50,
            perSlideRotate: 0,
            slideShadows: false,
          }}
          pagination={{
            el: ".testimonials__pagination",
            clickable: true,
            bulletClass: "testimonials__bullet",
            bulletActiveClass: "testimonials__bullet_active",
          }}
          allowTouchMove={!isFullScreen}
          className="testimonials__swiper"
        >
          {slides.map((r) => (
            <SwiperSlide key={r.name} className="testimonials__slide">
              <Review {...r} setFullScreen={setFullScreen} />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="testimonials__pagination" />
      </div>

      {/* Global fullscreen viewer; opened by child Review via setFullScreen(productObj) */}
      <FullScreen
        isOpen={Boolean(isFullScreen)}
        setOpen={(open) => setFullScreen(open ? isFullScreen : null)}
        product={isFullScreen || { files: [] }}
        hideControls={true}
      />
    </section>
  );
}

export default Testimonials;
